var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0000{fill:#167EE6;}\r\n\t.st0001{fill:#2860CC;}\r\n\t.st0002{fill:#FFAA00;}\r\n\t.st0003{fill:#F28D00;}\r\n\t.st0004{fill:#FFD500;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0000",
    d: "M490.1,322.5l-51.3-42.2c1.1-8.2,1.7-16.3,1.7-24.3s-0.6-16-1.7-24.3l51.3-42.2c6.2-5.1,7.7-13.8,3.8-20.7 l-43.4-75.2c-4-6.9-12.3-9.9-19.8-7.1l-62.3,23.3c-12.8-9.9-26.9-18-41.9-24.2L315.4,20c-1.3-7.9-8.1-13.6-16-13.6h-86.8 c-8,0-14.7,5.8-16,13.6l-10.9,65.7c-15,6.2-29.1,14.3-41.9,24.2L81.4,86.5c-7.4-2.8-15.8,0.2-19.8,7.1l-43.4,75.2 c-4,6.9-2.4,15.6,3.8,20.7l51.3,42.2c-1.1,8.2-1.7,16.3-1.7,24.3c0,8,0.6,16,1.7,24.3l-51.3,42.2c-6.2,5.1-7.7,13.8-3.8,20.7 l43.4,75.2c4,6.9,12.4,9.9,19.8,7.1l62.3-23.3c12.8,9.9,26.9,18,41.9,24.2l10.9,65.7c1.3,7.9,8.1,13.6,16,13.6h86.8 c7.9,0,14.7-5.7,16-13.6l10.9-65.7c15-6.2,29.1-14.3,41.9-24.2l62.3,23.3c7.4,2.8,15.8-0.2,19.8-7.1l43.4-75.2 C497.8,336.3,496.2,327.6,490.1,322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0001",
    d: "M493.8,343.2l-43.4,75.2c-4,6.9-12.4,9.9-19.8,7.1l-62.3-23.3c-12.8,9.9-26.9,18-41.9,24.2l-10.9,65.7 c-1.3,7.9-8.1,13.6-16,13.6h-42.7V6.4h42.7c8,0,14.7,5.8,16,13.6l10.9,65.7c15,6.2,29.1,14.3,41.9,24.2l62.3-23.3 c7.5-2.8,15.8,0.2,19.8,7.1l43.4,75.2c4,6.9,2.4,15.6-3.8,20.7l-51.3,42.2c1.1,8.2,1.7,16.3,1.7,24.3c0,8-0.6,16-1.7,24.3 l51.3,42.2C496.2,327.6,497.8,336.3,493.8,343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0002",
    d: "M310.9,321.1v179.7c-3,3-7.1,4.8-11.5,4.8h-86.8c-3.8,0-7.4-1.3-10.2-3.6V321.1H310.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0003",
    d: "M310.9,321.1v179.7c-3,3-7.1,4.8-11.5,4.8h-42.7V321.1H310.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0004",
    d: "M310.9,149.9v73.6L256.7,256l-54.3-32.6v-73.6c-39.9,20.3-65.1,60.8-65.1,106.1c0,68,55.4,119.3,119.3,119.4 c65.8,0,119.4-53.5,119.4-119.4C376,210.7,350.8,170.2,310.9,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0002",
    d: "M376,256c0-45.3-25.2-85.8-65.1-106.1v73.6L256.7,256v119.3C322.5,375.3,376,321.8,376,256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanel);
export default __webpack_public_path__ + "static/media/admin-panel.5c01f5ec9bf8ffbbe51c2236fb428aab.svg";
export { ForwardRef as ReactComponent };